import { Component, OnInit, Input, Output, OnDestroy, OnChanges, Inject } from '@angular/core';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { DataGridColumn, SortObject, SortType, DataGridRefreshEvent, DataGridEvent, DGMenuItem, DGButtons, StatusBarSummaryData, CellChangeEvent } from '../datagrid/datagrid.component';
import { FormItem, FormEvent, FormOption, TabItem } from '../form/FormItem';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';
import { PageMeta, PageMetaService, ResponseField, ResponseFieldDataSourceType } from '../../services/page-meta.service';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColumnState } from 'ag-grid-community';
import { ViasUserPref } from '../../services/vias-user-pref.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FieldTypes } from '../../FieldTypes';
import { Breadcrumb } from 'projects/viasng-core/src/public-api';

@Component({
  selector: 'vias-page',
  template: '',
})
export class PageComponent implements OnInit, OnDestroy, OnChanges {
  // Gerekli Bilgiler
  pageName: string = '';
  moduleName: string = '';
  pageTitle: string = '';
  pid: number = 0;
  editPid: number = 0;
  aid: number = 0;

  // Sayfa Settings
  hasDatagrid: boolean = true;
  hasButtonbar: boolean = true;
  hasEditForm: boolean = true;
  enableCharts: boolean = false;
  // Datagrid
  numLocale: string;
  columns: DataGridColumn[] = [];
  dataSource: object[] = [];
  sortObj: SortObject = { column_name: 'id', sort_type: SortType.Descending };
  pageno: number = 1;
  totalPages: number = 1;
  filtersObj: object = {};
  datagridId: string = '';
  dgButtons: DGButtons = {
    hasAddBtn: true, hasEditBtn: true, hasDeleteBtn: true
  };
  datagridOptions: {} = {};
  datagridSelectedItem: DataGridEvent;
  datagridColumnState: ColumnState[];
  rowClassRules: any;
  // sag tik menu
  contextMenuItems: (string | DGMenuItem)[];
  // sol menu
  sideMenuItems: ButtonBarItem[] = [];
  // sol menu
  statusBarItems: StatusBarSummaryData[] = [];
  // alt taraf Buttonbar
  buttonBarItems: ButtonBarItem[] = [];

  pageMeta: PageMeta;

  pageGeneralData: object = {};

  // Form
  formItems: FormItem[] = [];
  tabs: TabItem[] = [];
  tabSelectedIndex: number = 0;
  hasSubmitBtn: boolean = false;
  submitBtnText: string = '';
  submitAid: number;

  // passed data between pages
  data$: {};
  loadAid: number = 1;

  fromDialog: boolean = false;
  breadcrumbs: Breadcrumb[] = [];
  constructor(
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) protected dialogData: {} = {}
  ) {
    translate.use(globals.langLocale.substr(0, 2));

    if (dialogData['meta'] !== undefined) {
      if (dialogData['pageName'] !== undefined) {
        this.pageName = dialogData['pageName'];
      }
      if (dialogData['moduleName'] !== undefined) {
        this.moduleName = dialogData['moduleName'];
      }
      if (dialogData['aid'] !== undefined) {
        this.loadAid = dialogData['aid'] * 1;
      }
      this.fromDialog = true;
      this.generatePageFromMeta(dialogData['meta']);

    } else {
      this.next.queryParams.subscribe(params => {
        if (params.aid !== undefined) {
          this.loadAid = params.aid * 1; // numbera cevir
        }
        console.log(this.route.getCurrentNavigation());
        console.log(this.route);
        if (this.route.getCurrentNavigation().extras.queryParams !== undefined) {
          params = this.route.getCurrentNavigation().extras.queryParams;
        }
        this.data$ = params;
      });
    }
  }

  ngOnInit(): void {
    this.numLocale = this.globals.numLocale;
    const snapshot: ActivatedRouteSnapshot = this.next.snapshot;

    if (snapshot.data.pageName != null) {
      this.pageName = snapshot.data.pageName;
    }
    if (snapshot.data.moduleName != null) {
      this.moduleName = snapshot.data.moduleName;
    }
    if (snapshot.data.meta) {
      const meta = snapshot.data.meta;
      meta.then(
        m => {
          const metaData: PageMeta = new m();
          this.generatePageFromMeta(metaData);
        }
      ).catch(err => {
        console.log('!!!!!err!!!', err);
      });
    }
    // let url = './';
    // if (snapshot.data.moduleUrl != null) {
    //   url = snapshot.data.moduleUrl;
    // }
    // // console.log(this.moduleName);
    // if (this.moduleName.length > 0 && this.pageName.length > 0) {
    //   const pms: PageMetaService = new PageMetaService();
    //   pms.getPage(url, this.moduleName, this.pageName).then(
    //     metaData => {
    //       console.log(metaData);
    //       this.generatePageFromMeta(metaData);
    //     }
    //   ).catch(err => {
    //     console.log('!!!!!err!!!', err);
    //   });
    // }
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
  }

  generatePageFromMeta(pageMeta: PageMeta): void {

    // activated route snapshot icindeki data objesini pagemetaya yaz
    if (!this.fromDialog) {
      pageMeta.snapShotData = {
        ...this.next.snapshot.data,
        ...this.next.snapshot.queryParams
      };
    }
    if(pageMeta.datagridOptions !== undefined){
      this.datagridOptions = {
       ...this.datagridOptions,
        ...pageMeta.datagridOptions
      }
    }
    if(pageMeta.dataGridInitialSort !== undefined){
      this.sortObj = pageMeta.dataGridInitialSort;
    }
    this.datagridOptions['sortObj'] = this.sortObj;
    if (pageMeta.datagridFirstLoadError !== undefined) {
      this.translate.get(pageMeta.datagridFirstLoadError).subscribe((translated: string) => {
        this.datagridOptions['firstLoadError'] = translated;
      });
    }
    this.translate.get('errorTexts.e_general_053').subscribe((translated: string) => {
      this.datagridOptions['emptyErrorText'] = translated;
    });
    if (pageMeta.rowClassRules !== undefined) {
      this.rowClassRules = pageMeta.rowClassRules;
    }
    // bunlar alt siniflara ovverride edilen yere tasinmali!!!
    // this.columns = pageMeta.dataGridColumns;
    if (pageMeta.tabs !== undefined) {
      pageMeta.tabs.forEach(t => {
        if (typeof (t) === 'string') {
          this.translate.get(t).subscribe((translated: string) => {
            this.tabs.push({
              label: translated
            });
          });
        } else {
          this.translate.get(t.label).subscribe((translated: string) => {
            t.label = translated;
            if (t.disabledFunc !== undefined) {
              t.disabled = t.disabledFunc(this);
            }
            this.tabs.push(t);
          });
        }
      });
    }
    if (pageMeta.tabSelectedIndex !== undefined){
      this.tabSelectedIndex = pageMeta.tabSelectedIndex;
    }
    if (pageMeta.hasSubmitBtn !== undefined) {
      this.hasSubmitBtn = pageMeta.hasSubmitBtn;
    }
    if (pageMeta.submitBtnText !== undefined) {
      this.translate.get(pageMeta.submitBtnText).subscribe((translated: string) => {
        this.submitBtnText = translated;
      });
    }
    this.datagridId = pageMeta.pid + '_' + this.moduleName + '_' + this.pageName;

    if (this.globals.userPref.tableState !== undefined) {
      let tsres: ColumnState[];
      this.globals.userPref.tableState.forEach(ts => {
        if (ts.tableId === this.datagridId) {
          tsres = ts.state;
        }
      });
      this.datagridColumnState = tsres;
    }

    this.pid = pageMeta.pid;
    if (pageMeta.editPid !== undefined) {
      this.editPid = pageMeta.editPid;
    }

    if (pageMeta.dataGridColumns !== undefined) {
      this.translateDGCols(pageMeta.dataGridColumns);
    }
    if (pageMeta.formItems !== undefined) {
      this.translateFormCols(pageMeta.formItems);
    }

    if (pageMeta.buttonBarItems !== undefined) {
      this.buttonBarItems = pageMeta.buttonBarItems;
    }
    if (pageMeta.datagridSideMenuItems !== undefined) {
      this.sideMenuItems = pageMeta.datagridSideMenuItems;
    }
    if (pageMeta.datagridStatusBarItems !== undefined) {
      this.statusBarItems = pageMeta.datagridStatusBarItems;
    }
    if (pageMeta.datagridContextMenuItems !== undefined) {
      this.contextMenuItems = pageMeta.datagridContextMenuItems;
    }

    if (pageMeta.datagridSelectBtnClickHandler !== undefined) {
      this.datagridSelectBtnClickHandler = pageMeta.datagridSelectBtnClickHandler;
    }
    if (pageMeta.datagridCellChangeHandler !== undefined) {
      this.datagridCellChangeHandler = pageMeta.datagridCellChangeHandler;
    }
    if (pageMeta.datagridDoubleClickHandler !== undefined) {
      this.datagridDoubleClickHandler = pageMeta.datagridDoubleClickHandler;
    }
    if (pageMeta.enableCharts !== undefined){
      this.enableCharts = pageMeta.enableCharts;
    }
    // bu islem listone servis sonucunda dolarak calisacak
    //this.formItems = pageMeta.formItems;

    // console.log(pageMeta);

    this.pageMeta = pageMeta;
    // tslint:disable-next-line: max-line-length
    let listPageLabel = 'pageNames.page_' + String(Number(this.pageMeta.pid) + (this.pageMeta.listAid !== undefined ? Number(this.pageMeta.listAid) : 0));
    if (this.pageMeta.listPageLabel !== undefined){
      listPageLabel = this.pageMeta.listPageLabel;
    }
    // set breadcrumbs
    if (this.hasEditForm){
      if (this.pageMeta.listPageName !== undefined && this.pageMeta.listAid !== undefined){
        this.breadcrumbs.push({ label: listPageLabel , url: '#/' + this.moduleName + '/' + this.pageMeta.listPageName });
      }
      let editPageLabel = this.pageName;
      if (this.pageMeta.editPageLabel !== undefined){
        editPageLabel = this.pageMeta.editPageLabel;
      }
      this.breadcrumbs.push({ label: editPageLabel, url: 'javascript:void(0)' });
    }else{
      this.breadcrumbs.push({ label: listPageLabel , url: 'javascript:void(0)' });
    }
  }

  translateDGCols(pmg: DataGridColumn[]): void {
    pmg.forEach(e => {
      if (e.filterDataSourceFunc !== undefined) {
        e.filterDataSource = e.filterDataSourceFunc();
        e.filterDataSource.forEach(el => {
          this.translate.get(el.label).subscribe((translated: string) => {
            el.label = translated;
          });
        });
        e.editDataSource = e.filterDataSource;
      }
      this.translate.get(e.headerText).subscribe((translated: string) => {
        e.headerText = translated;
      });
    });
  }
  translateFormCols(pmg: FormItem[]): void {
    pmg.forEach(e => {
      if (e.options !== undefined) {
        // e.optionsDataSourceFunc !== undefined ||
        // e.options = e.optionsDataSourceFunc();
        e.options.forEach(el => {
          this.translate.get(el.label).subscribe((translated: string) => {
            el.label = translated;
          });
        });
      }
      if (e.tableColumns !== undefined) {
        e.tableColumns.forEach(tc => {
          if (tc.filterDataSourceFunc !== undefined) {
            tc.filterDataSource = tc.filterDataSourceFunc();
            tc.filterDataSource.forEach(el => {
              this.translate.get(el.label).subscribe((translated: string) => {
                el.label = translated;
              });
            });
            tc.editDataSource = tc.filterDataSource;
          }
          this.translate.get(tc.headerText).subscribe((translated: string) => {
            tc.headerText = translated;
          });
        });
      }
      this.translate.get(e.label).subscribe((translated: string) => {
        e.label = translated;
      });
    });
  }
  /**
   * Datagrid sort, sayfa degisim ve filtre durumunun handler methodu
   * @param $event DataGridRefreshEvent
   */
  datagridRefreshHandler($event: DataGridRefreshEvent): void {
    this.sortObj = $event.sort;
    this.datagridOptions['sortObj'] = this.sortObj;
    this.pageno = $event.pageNo;
    // filtersobj icindekilere degisiklik ekliyoruz. mevcutlari kaldirmiyoruz.
    // this.filtersObj = $event.filters;
    for (const fo in $event.filters) {
      this.filtersObj[fo] = $event.filters[fo];
    }
    //Filtreden çıkartılan alanların filtersObj dan çıkartılması için
    for (const fi in this.filtersObj){
      if ($event.filters[fi] === undefined){
        delete this.filtersObj[fi];
      }
    }
    console.log($event);
    this.refreshData();
  }

  /**
   * Button bar tiklaninca methoda gonderen handler
   * @param $event Buttonbar event
   */
  butonclickHandler(event: ButtonBarItem): void { }

  formItemChangeOption(itemName: string, data: FormOption[]): void {
    const index = this.formItems.findIndex(e => e['name'] === itemName);
    this.formItems[index].options = data;
  }

  /**
   * Form submit edilince calisan handler method
   * @param $event FormEvent
   */
  formSubmitHandler($event: FormEvent): void { }
  /**
   * Form icinde bir sey degisince edilince calisan handler method
   * @param $event object
   */
  formChangeHandler($event: object): void { }

  tabSelectedIndexChange(index: number): void { }

  /**
   * viasService call with pid aid
   * standart listeleme icin
   * handle promise response
   * no need o
   */
  refreshData(): void {
    let sendData: object = {
      sort: this.sortObj,
      page_no: this.pageno,
      filters: '',
      ng_filters: this.filtersObj
    };

    this.runInitDataFieldsFunction();

    if (this.pageMeta.initDataFields !== undefined) {
      sendData = {
        ...sendData,
        ...this.pageMeta.initDataFields
      };
    }
    console.log(sendData);
    this.viasService.send(this.pid, this.aid, sendData).then(
      response => {
        if (response.error !== null && response.error !== undefined && response.error.length > 0) {
          this.globals.handleErrors(response.error);
        }
        this.viasServiceHandler(response);
      },
      err => {
        alert(err);
        console.log(err);
      });
  }

  runInitDataFieldsFunction(): void {
    if (this.pageMeta.initDataFieldsFunction !== undefined) {
      const ifields: {} = this.pageMeta.initDataFieldsFunction();
      if (this.pageMeta.initDataFields !== undefined) {
        this.pageMeta.initDataFields = {
          ...this.pageMeta.initDataFields,
          ...ifields
        };
      } else {
        this.pageMeta.initDataFields = ifields;
      }
    }
  }

  /**
   * viasService icin Handler
   * OVERRIDE
   * standart listeleme sonucu
   */
  viasServiceHandler(r: ViasResponse): void {
    console.log(r);
    console.log('------cevap geldi');
  }

  responseFieldParserForForm(
    data: object,
    responseFields: ResponseField[],
    formItems: FormItem[]
  ): FormItem[] {
    for (let i = 0; i < formItems.length; i++) {
      const formItem = formItems[i];
      if (formItem.id === undefined) {
        formItem.id = formItem.name;
      }
      let datax = {};
      // Table columns set
      if (formItem.type === FieldTypes.Table) {
        formItem.tableColumns.forEach(col => {
          if (col.filterDataIdField === undefined) {
            col.filterDataIdField = 'id';
          }
          if (col.filterDataLabelField === undefined) {
            col.filterDataLabelField = 'name';
          }
          if (col.filterField === undefined) {
            col.filterField = col.dataField;
          }
          if (col.sortField === undefined) {
            col.sortField = col.dataField;
          }
          if (col.editable !== undefined) {
            if (col.editable) {
              if (col.editDataIdField === undefined) {
                col.editDataIdField = col.filterDataIdField;
              }
              if (col.editDataLabelField === undefined) {
                col.editDataLabelField = col.filterDataLabelField;
              }
              if (col.editField === undefined) {
                col.editField = col.filterField;
              }
            }
          }
        });
      }

      responseFields.forEach(rf => {
        if (rf.responseFieldType === ResponseFieldDataSourceType.formDataSource) {
          if (data[rf.fieldName] !== undefined) {
            datax = data[rf.fieldName];
            formItem.value = datax[formItem.id];
          }
        }
        // formun formDataSource dışında kullandığı bir data var ise
        if (rf.responseFieldType === ResponseFieldDataSourceType.formFieldDataSource) {
          if (formItem.dataSource !== undefined) {
            if (formItem.dataSource === rf.fieldName) {
              if (data[rf.fieldName] !== undefined) {
                datax = data[rf.fieldName];
                if (datax.hasOwnProperty('length')) {
                  formItem.value = datax;
                } else {
                  formItem.value = datax[formItem.id];
                }
              }
            }
          }
        }
      });

      // option ile yazili form itemlar !!!
      // response field lardan al getir
      if (formItem.optionsFieldName !== undefined) {
        responseFields.forEach(rf => {
          if (rf.responseFieldType === ResponseFieldDataSourceType.formFieldDataSource) {
            if (rf.componentName === formItem.optionsFieldName) {
              // tablo var ise diye tablo datasini da doldur.
              if (formItem.tableColumns !== undefined) {
                // Columns FilterDataSource, EditDataSource
                formItem.tableColumns.forEach((tbCol, key) => {
                  if (tbCol.filterField !== undefined && tbCol.dataType === FieldTypes.AutoComplete) {
                    const tbRf = responseFields.find(dt => dt.componentName === tbCol.filterField);
                    if (tbRf !== undefined) {
                      if (data[tbRf.fieldName] !== undefined) {
                        tbCol.filterDataSource = [];
                        for (const [key, obj] of Object.entries(data[tbRf.fieldName])) {
                          if (obj !== undefined) {
                            if (rf.isKeyValuePair !== undefined) {
                              tbCol.filterDataSource.push({
                                // tslint:disable-next-line: radix
                                value: parseInt(key),
                                label: obj.toString()
                              });
                            } else {
                              if (obj[tbCol.filterDataLabelField].toString() !== undefined) {
                                const pushedData = {
                                  // tslint:disable-next-line: radix
                                  value: obj[tbCol.filterDataIdField],
                                  label: obj[tbCol.filterDataLabelField]
                                };
                                if (rf.connectedComponentName !== undefined) {
                                  pushedData[rf.connectedComponentName] = obj[rf.connectedComponentName];
                                }
                                tbCol.filterDataSource.push(pushedData);
                              }
                            }
                          }
                        }
                        tbCol.editDataSource = tbCol.filterDataSource;
                        formItem.tableColumns.splice(key, 1, tbCol);
                      }
                    }
                  }
                });
                formItem.tableDataSource = [];
                formItem.tableDataSource = data[rf.fieldName];
                if (formItem.onChangedFunc !== undefined) {
                  formItem.onChangedFunc(formItem.tableDataSource, this);
                }
              } else {
                formItem.options = [];
                // digerlerini ekle
                if (data[rf.fieldName] !== undefined) {
                  for (const [key, obj] of Object.entries(data[rf.fieldName])) {
                    if (obj !== undefined) {
                      if (rf.isKeyValuePair !== undefined) {
                        formItem.options.push({
                          data: key,
                          label: obj.toString()
                        });
                      } else {
                        if (obj[formItem.optionsDataLabelField].toString().length > 0) {
                          formItem.options.push({
                            data: obj[formItem.optionsDataIdField],
                            label: obj[formItem.optionsDataLabelField]
                          });
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
      // changed lifecyle icin
      // kolonu geri yaz
      formItems.splice(i, 1, formItem);
    }
    responseFields.forEach(rf => {
      if (rf.responseFieldType === ResponseFieldDataSourceType.pageGeneralDataSource) {
        if (data[rf.fieldName] !== undefined) {
          this.pageGeneralData[rf.fieldName] = data[rf.fieldName];
        }
      }
    });
    return formItems;
  }
  responseFieldParserForDataGrid(
    data: object,
    responseFields: ResponseField[],
    dataGridColumns: DataGridColumn[]
  ): { dataSource: object[], dataGridColumns: DataGridColumn[] } {

    let dataSource: object[] = [];

    // bazi alanlari set et.
    dataGridColumns.forEach(col => {
      if (col.filterDataIdField === undefined) {
        col.filterDataIdField = 'id';
      }
      if (col.filterDataLabelField === undefined) {
        col.filterDataLabelField = 'name';
      }
      if (col.filterField === undefined) {
        col.filterField = col.dataField;
      }
      if (col.sortField === undefined) {
        col.sortField = col.dataField;
      }
      if (col.editable !== undefined) {
        if (col.editable) {
          if (col.editDataIdField === undefined) {
            col.editDataIdField = col.filterDataIdField;
          }
          if (col.editDataLabelField === undefined) {
            col.editDataLabelField = col.filterDataLabelField;
          }
          if (col.editField === undefined) {
            col.editField = col.filterField;
          }
        }
      }
    });

    responseFields.forEach(rf => {
      if (rf.responseFieldType === ResponseFieldDataSourceType.datagridDataSource) {
        if (data[rf.fieldName] !== undefined) {
          dataSource = data[rf.fieldName];
        }
      } else if (rf.responseFieldType === ResponseFieldDataSourceType.datagridFilterDataSource) {
        // colonu bul
        const colInd: number = dataGridColumns.findIndex(
          x => x.filterField === rf.componentName
        );
        const col: DataGridColumn = dataGridColumns[colInd];
        col.filterDataSource = [];
        // digerlerini ekle
        if (data[rf.fieldName] !== undefined) {
          for (const [key, obj] of Object.entries(data[rf.fieldName])) {
            if (obj !== undefined) {
              if (rf.isKeyValuePair !== undefined) {
                col.filterDataSource.push({
                  // tslint:disable-next-line: radix
                  value: parseInt(key),
                  label: obj.toString()
                });
              } else {
                if (obj[col.filterDataLabelField].toString() !== undefined) {
                  const pushedData = {
                    // tslint:disable-next-line: radix
                    value: obj[col.filterDataIdField],
                    label: obj[col.filterDataLabelField]
                  };
                  if (rf.connectedComponentName !== undefined) {
                    pushedData[rf.connectedComponentName] = obj[rf.connectedComponentName];
                  }
                  col.filterDataSource.push(pushedData);
                }
              }
            }
          }
        }
        // edit datasi filter ile ayni
        col.editDataSource = col.filterDataSource;
        // changed lifecyle icin
        // kolonu geri yaz
        dataGridColumns.splice(colInd, 1, col);
      } else if (rf.responseFieldType === ResponseFieldDataSourceType.pageGeneralDataSource) {
        if (data[rf.fieldName] !== undefined) {
          this.pageGeneralData[rf.fieldName] = data[rf.fieldName];
        }
      }
    });

    return { dataSource, dataGridColumns };
  }

  /**
   * Datagrid tek tiklaninca calisan method
   * @param event DataGridEvent
   */
  // datagridClickHandler?(index: number, item: DataGridColumn);
  datagridClickHandler?(event: DataGridEvent): void {
    this.datagridSelectedItem = event;
  }
  datagridSelectBtnClickHandler?(event: DataGridEvent): void {
  }
  datagridCellChangeHandler?(event: CellChangeEvent): void {
  }
  datagridAddBtnClickHandler?(event: DataGridEvent): void {
    // this.route.navigate('');
  }
  datagridEditBtnClickHandler?(event: DataGridEvent): void {
    console.log(event.item);
  }
  datagridDeleteBtnClickHandler?(event: DataGridEvent): void {
    console.log(event.item);
  }
  /**
   * Datagrid cift tiklaninca calisan method
   * @param event DataGridEvent
   */
  datagridDoubleClickHandler?(event: DataGridEvent): void;

  datagridColumnStateChangeHandler($event): void {
    const usrprf: ViasUserPref = this.globals.userPref;
    if (usrprf.tableState === undefined) {
      usrprf.tableState = [];
    }
    let found = false;
    usrprf.tableState.forEach(ts => {
      if (ts.tableId === this.datagridId) {
        ts.state = $event.state;
        found = true;
      }
    });
    if (!found) {
      usrprf.tableState.push($event);
    }
    this.globals.userPref = usrprf;
    this.globals.userPrefService.setPref(usrprf);
  }


  /**
   * Edit isleminden once calisan method
   * @param index selected item index
   * @param item DataGridColumn before edit
   */
  datagridItemEditBeginHandler?(index: number, item: DataGridColumn): void;
  /**
   * Edit isleminden sonra calisan method
   * @param index selected item index
   * @param item DataGridColumn after edit
   */
  datagridItemEditendHandler?(index: number, item: DataGridColumn): void;

  onCellValueChanged?(params): void;
}
